import { render, staticRenderFns } from "./TeamMode.vue?vue&type=template&id=1d00d64c&scoped=true&"
import script from "./TeamMode.vue?vue&type=script&lang=js&"
export * from "./TeamMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d00d64c",
  null
  
)

export default component.exports